import { deviceAlarmMappingsService } from "client-app-core";
import * as t from "./actionTypes";

const getAllDeviceAlarmMappingsAction = data => {
	return {
		type: t.GET_ALL_DEVICE_ALARM_MAPPINGS,
		payload: data
	};
};

export const getAllDeviceAlarmMappings = () => {
	return dispatch => {
		deviceAlarmMappingsService.getAllDeviceAlarmMappings((err, response) => {
			if (err) {
				console.error("Error fetching device alarm mappings:", err);
			} else if (response) {
				dispatch(getAllDeviceAlarmMappingsAction(response));
			}
		});
	};
};
